import type { ChatMessage as ChatMessageType } from '@/models/chat-message';
import UserMessage from '@/components/chat/ChatMessage/UserMessage';
import AssistantMessage from '@/components/chat/ChatMessage/AssistantMessage';
import AssistantIntermediateMessage from '@/components/chat/ChatMessage/AssistantIntermediateMessage';
import SystemMessage from '@/components/chat/ChatMessage/SystemMessage';
import ToolCallMessage from '@/components/chat/ChatMessage/ToolCallMessage';
import ToolResponseMessage from '@/components/chat/ChatMessage/ToolResponseMessage';
import SystemQueryMessage from '@/components/chat/ChatMessage/SystemQueryMessage';
import SystemQueryResponseMessage from '@/components/chat/ChatMessage/SystemQueryResponseMessage';

interface ChatMessageProps {
  message: ChatMessageType;
  debugMode?: boolean;
}

export default function ChatMessage({ message, debugMode = false }: ChatMessageProps) {
  switch (message.role) {
    case 'user':
      return <UserMessage message={message} debugMode={debugMode} />;
    
    case 'assistant':
      return <AssistantMessage message={message} debugMode={debugMode} />;
    
    case 'assistant_intermediate':
      return <AssistantIntermediateMessage message={message} />;
    
    case 'system':
      return <SystemMessage message={message} />;
    
    case 'tool_call':
      return <ToolCallMessage message={message} />;
    
    case 'tool_response':
      return <ToolResponseMessage message={message} />;
    
    case 'system_query':
      return <SystemQueryMessage message={message} />;
    
    case 'system_query_response':
      return <SystemQueryResponseMessage message={message} />;
    
    default:
      // Fallback for unknown message types
      return (
        <div className="my-3">
          <div className="bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg p-3">
            <div className="text-sm text-gray-600 dark:text-gray-300">
              Unknown message type: {message.role}
            </div>
            <div className="mt-2 text-sm text-gray-800 dark:text-gray-200">
              {message.content}
            </div>
          </div>
        </div>
      );
  }
}